export default "__VITE_ASSET__DDsTtoWa__"